'use strict';
import * as $j_app$002edata$002etypes$005fout$005fof$005fstock$005fmediation$005freport$0024package$0024$002dOut$002dOf$002dStock$002dMedication$002dReport$002dId$0024 from "./app.data.types_out_of_stock_mediation_report$package$-Out-Of-Stock-Medication-Report-Id$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$52() {
}
export { $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$52 as $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$52 };
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$52.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$52.prototype.constructor = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$52;
/** @constructor */
function $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$52() {
}
export { $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$52 as $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$52 };
$h_Lapp_api_DrugRequestsAcceptedListItem$$anon$52.prototype = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$52.prototype;
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$52.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$52.prototype.apply__O = (function() {
  return $j_app$002edata$002etypes$005fout$005fof$005fstock$005fmediation$005freport$0024package$0024$002dOut$002dOf$002dStock$002dMedication$002dReport$002dId$0024.$m_Lapp_data_types\uff3fout\uff3fof\uff3fstock\uff3fmediation\uff3freport$package$OutOfStockMedicationReportId$().given_Schema_Type__Lsttp_tapir_Schema();
});
var $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$52 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestsAcceptedListItem$$anon$52, "app.api.DrugRequestsAcceptedListItem$$anon$52", ({
  Lapp_api_DrugRequestsAcceptedListItem$$anon$52: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$52 as $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$52 };
//# sourceMappingURL=app.api.-Drug-Requests-Accepted-List-Item$$anon$52.js.map
